import axios from "../plugins/parseAxios";
export class UserAPI {
  constructor(props) { }
  static logIn(payload) {
    return axios.post("login", {
      username: payload.username,
      password: payload.password,
    });
  }
  static changeUserPassword(payload) {
    return axios.post("functions/changeUserPassword", payload)
  }
  static updateUser(payload) {
    return axios.post("functions/updateUser", payload)
  }
  static signUp(payload) {
    return axios.post("users", payload);
  }
  static logOut() {
    return axios.post("logout");
  }
  static getUserInfo() {
    return axios.post("functions/getUserInfo");
  }
  static getUserByTel(tel) {
    return axios.post("functions/getUserByTel", { tel });
  }
  static loginSSO(payload) {
    return axios.post("functions/loginSSO", payload);
  }
  static become() {
    return axios.get("sessions/me");
  }
}
